// Simple patterns to detect suspicious inbox rule names
const SUSPICIOUS_PATTERNS = {
    singleChar: /^.$/,                          // Single character: ".", "x", "a", "1"
    repeatedChar: /^(.)\1{2,}$/,               // Repeated chars: "aaa", "xxx", "111", "..."
    keyboardPattern: /^(qwerty|asdf|zxcv|1234|abcd|qwertyui|asdfgh|zxcvbn)$/i,  // Keyboard patterns
    numbersOnly: /^\d+$/,                      // Numbers only: "123", "456"
    specialCharsOnly: /^[^a-zA-Z0-9]+$/,       // Special chars only: "...", "___", "---"
};

// Common meaningful words to whitelist
const MEANINGFUL_WORDS = new Set([
    // Email/Rule related
    'rule', 'filter', 'spam', 'junk', 'important', 'priority', 'urgent', 'auto', 'automatic',
    'delete', 'move', 'forward', 'redirect', 'copy', 'archive', 'sort', 'organize',
    'inbox', 'folder', 'email', 'mail', 'message', 'notification', 'alert', 'reminder',
    
    // Business related  
    'work', 'business', 'office', 'company', 'corporate', 'professional', 'meeting',
    'boss', 'manager', 'client', 'customer', 'vendor', 'supplier', 'partner',
    'project', 'task', 'deadline', 'report', 'invoice', 'receipt', 'bill', 'payment',
    
    // Personal
    'personal', 'private', 'family', 'friend', 'social', 'home', 'vacation', 'travel',
    'newsletter', 'subscription', 'update', 'news', 'blog', 'article', 'review',
    
    // Technical
    'system', 'admin', 'support', 'help', 'security', 'backup', 'sync', 'update',
    'notification', 'alert', 'warning', 'error', 'log', 'debug', 'test', 'temp',
    
    // Categories
    'banking', 'finance', 'shopping', 'order', 'delivery', 'shipping', 'tracking',
    'social', 'media', 'photo', 'video', 'document', 'file', 'attachment'
]);

/**
 * Quick check if string contains any meaningful word parts
 */
function containsMeaningfulWord(str: string): boolean {
    return MEANINGFUL_WORDS.has(str) || 
           Array.from(MEANINGFUL_WORDS).some(word => str.includes(word));
}

/**
 * Detects if an inbox rule name appears suspicious or meaningless
 * Common patterns from compromised accounts: ".", "x", "aaa", "qwerty", "123", "..."
 */
export function isSuspiciousRuleName(name: string): boolean {
    if (!name || name.length === 0) return false;
    
    const trimmed = name.trim().toLowerCase();
    
    // Very short names are suspicious
    if (trimmed.length <= 2) return true;
    
    // Skip if contains meaningful words
    if (containsMeaningfulWord(trimmed)) return false;
    
    // Check against known suspicious patterns
    return Object.values(SUSPICIOUS_PATTERNS).some(pattern => pattern.test(trimmed));
}